









import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import FormIndex from './customForm/form/formIndex.vue';

/**
 * 添加RG user
 *
 * @author liyuyao
 * @date 03/22/2020
 */
@Component({
    components: {
        FormIndex
    }
})
export default class AddRgUserDialog extends Vue {
    @Prop({ default: false })
    visible: Boolean;

    @Prop()
    fieldSchema: any;

    show: Boolean = false;

    @Watch('visible', { immediate: true })
    onShowChanged(val) {
        this.show = val;
    }
    close() {
        this.$emit('update:visible', false);
    }
}
